import { css } from '@emotion/react';
import styled from '@emotion/styled';

const sizes = {
  size1: {
    size: '2rem',
    fontSize: 'size1',
    bottomGap: '-0.5rem',
    rightGap: '-0.5rem',
  },
  size2: {
    size: '1.5rem',
    fontSize: 'size2',
    bottomGap: '-0.25rem',
    rightGap: '-0.25rem',
  },
  size3: {
    size: '1.25rem',
    fontSize: 'size3',
    bottomGap: '-0.25rem',
    rightGap: '-0.25rem',
  },
  size4: {
    size: '1rem',
    fontSize: 'size3',
    bottomGap: '-0.25rem',
    rightGap: '-0.25rem',
  },
  size5: {
    size: '1rem',
    fontSize: 'size3',
    bottomGap: '-0.25rem',
    rightGap: '-0.5rem',
  },
};

const mobileSizeMap = {
  size1: 'size2',
  size2: 'size3',
  size3: 'size3',
  size4: 'size4',
  size5: 'size5',
};

const baseStyles = ({ theme, admin, size }) =>
  css`
    align-items: center;
    background-color: ${admin
      ? theme.colors.avatar.badge.bgAdm
      : theme.colors.avatar.badge.bgUser};
    bottom: ${sizes[mobileSizeMap[size]].bottomGap};
    border-radius: ${theme.border.radius.rounded};
    color: ${theme.colors.avatar.badge.foreground};
    display: flex;
    font-weight: ${theme.typography.fontWeights.bold};
    justify-content: center;
    position: absolute;
    right: ${sizes[mobileSizeMap[size]].rightGap};

    ${theme.mediaQueries.lg} {
      bottom: ${sizes[size].bottomGap};
      right: ${sizes[size].rightGap};
    }
  `;

const sizeStyles = ({ theme, size }) => css`
  font-size: ${theme.typography.texts[sizes[mobileSizeMap[size]].fontSize]
    .fontSize};
  height: ${sizes[mobileSizeMap[size]].size};
  width: ${sizes[mobileSizeMap[size]].size};

  ${theme.mediaQueries.lg} {
    font-size: ${theme.typography.texts[sizes[size].fontSize].fontSize};
    height: ${sizes[size].size};
    width: ${sizes[size].size};
  }
`;

const StyledAvatarBadge = styled('div')`
  ${baseStyles}
  ${sizeStyles}
`;

function AvatarBadge({ ...props }) {
  return <StyledAvatarBadge {...props} />;
}

export default AvatarBadge;
